import React, { FC } from 'react';
import { Route, RouteComponentProps } from 'react-router';

import UsersTable from '../components/users/table';
import UserEdit from '../components/users/edit';
import UserCreate from '../components/users/create';

type RouteProps = RouteComponentProps<
  {
    id: string;
  },
  { statusCode?: number },
  unknown
>;

const UsersPage: FC<RouteProps> = () => {
  return (
    <>
      <Route exact path="/users/edit" component={UserEdit} />
      <Route exact path="/users/create" component={UserCreate} />
      <Route exact path="/users/" component={UsersTable} />
    </>
  );
};

export default UsersPage;
